import styled from "styled-components";

export const CompanyButtonContainer = styled.div.attrs({
})`
    width: 100%;
    display: flex;
    gap: 16px;
    border-top: 1px solid ${props => props.theme.palette.colors.border};
    padding-top: 24px;
`;

export const CloseContainer = styled.div.attrs({
})`
    display: flex;
    justify-content: flex-end;
    width: 100%;
`;


export const VideoContainer = styled.div.attrs({})`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 16px 0;
`;

export const StyledVideo = styled.video.attrs({})`
  width: 100%;
  height: auto;
  max-height: calc(80vh - 160px);
  background: ${p => p.theme.palette.primary.main};
  border-radius: 8px;
  outline: none;
`;

export const StyledImg = styled.div.attrs({})`
  width: 100%;
  padding-top: 56.25%;
  position: relative;
  max-height: calc(80vh - 160px);
  border-radius: 8px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  overflow: hidden;
  cursor: pointer;

  & > img {
    display: none; 
  }
`;
